/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Createinchat2Inputs */

const zh_learn_createinchat2 = /** @type {(inputs: Learn_Createinchat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去聊天页创建一个`)
};

const en_learn_createinchat2 = /** @type {(inputs: Learn_Createinchat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to Chat to create one`)
};

const es_learn_createinchat2 = /** @type {(inputs: Learn_Createinchat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ve al chat para crear una`)
};

/**
* | output |
* | --- |
* | "Go to Chat to create one" |
*
* @param {Learn_Createinchat2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_createinchat2 = /** @type {((inputs?: Learn_Createinchat2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Createinchat2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_createinchat2(inputs)
	if (locale === "en") return en_learn_createinchat2(inputs)
	return es_learn_createinchat2(inputs)
});
export { learn_createinchat2 as "learn_createInChat" }